import { render, staticRenderFns } from "./TxRoot.vue?vue&type=template&id=6b9e0492"
import script from "./TxRoot.vue?vue&type=script&lang=js"
export * from "./TxRoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports